export default __webpack_public_path__ + "static/iPhoneFrameCutOffBlack-98552667991523a2ebb04670b6a2bd64.png";